import { h, Fragment, VNode } from "preact";

import CSSProperties from "../../../foundation/model/CSSProperties";
import classname from "../../../foundation/utils/classname";
import { PopoverAlignment, PopoverPosition } from "../Popover";
import Tooltip from "../Tooltip";

import styles from "./FooterMenu.module.css";

interface Props {
    class?: string;
    style?: CSSProperties;
    labelText: string;
    noSelectedItemTooltipText?: string;
    buttons: VNode;
    newFeatureLabel?: VNode;
    menu?: VNode;
    hasSelectedItems: boolean;
}

export default function FooterMenu({
    class: cssClass,
    style,
    labelText,
    noSelectedItemTooltipText,
    buttons,
    newFeatureLabel,
    menu,
    hasSelectedItems
}: Props) {
    function renderLabel() {
        const label = (
            <div class={classname(styles.label, "caption-2 semibold")}>
                {labelText}
            </div>
        );

        if (!hasSelectedItems && noSelectedItemTooltipText) {
            return (
                <Tooltip
                    class={styles.tooltip}
                    alignment={PopoverAlignment.Center}
                    position={PopoverPosition.Top}
                    title={noSelectedItemTooltipText}>
                    {label}
                </Tooltip>
            );
        }

        return label;
    }

    return (
        <div
            class={classname(styles.footerMenu, cssClass, {
                [styles.hasSelectedItems]: hasSelectedItems
            })}
            style={style}>
            {renderLabel()}
            <div class={styles.buttonGroup}>
                {buttons}
            </div>
            {!!(menu || newFeatureLabel) && (
                <>
                    <div class={styles.separator}/>
                    <div class={styles.newFeatureLabelAndMenu}>
                        {newFeatureLabel}
                        {menu}
                    </div>
                </>
            )}
        </div>
    );
}
